var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"2455cd28fa2d744d667697b17767e713d2895510"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/flow";

/* eslint-disable filenames/match-regex */
import * as Sentry from '@sentry/nextjs'

import { defaultSentryClientConfig } from '@twisto/nextjs/sentry-config'

Sentry.init({
  ...defaultSentryClientConfig,
  dsn: 'https://dde2112cb8bdef48c62a902e77918e35@o430641.ingest.sentry.io/4506588604137472',
  replaysOnErrorSampleRate: 0.05,
  integrations: [Sentry.replayIntegration()],
})
